import React from 'react';
import { twMerge } from 'tailwind-merge';
interface SectionHeadingProps {
  children: React.ReactNode;
  className?: string;
  centered?: boolean;
}
export function SectionHeading({
  children,
  className,
  centered = false
}: SectionHeadingProps) {
  return <div className={twMerge('mb-10', centered && 'text-center', className)} data-id="element-191">
      <h2 className="text-3xl md:text-4xl lg:text-[2.4rem] leading-[1.15] mb-4 text-balance" data-id="element-192">
        {children}
      </h2>
      <div className={twMerge('w-[60px] h-1 bg-mc-yellow rounded-full', centered ? 'mx-auto' : 'ml-0')} data-id="element-193" />
    </div>;
}